import React from "react";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { Search, ShoppingCartOutlined } from "@mui/icons-material";
import { Divider } from "@mui/material";
import MilitaryTechOutlinedIcon from "@mui/icons-material/MilitaryTechOutlined";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const StoreRewards = () => {
  const navigate = useNavigate();

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div className="flex justify-between py-5 px-3">
        <p className="text-lg">
          <ArrowBackIcon
            className="!mr-4"
            onClick={() => navigate("/profile")}
          />
          Store rewards
        </p>
        <div className="flex gap-5">
          <Search />
          <ShoppingCartOutlined onClick={() => navigate("/cart")} />
        </div>
      </div>
      <div className="p-4">
        <div className="flex gap-10 border-2 border-blue-400 justify-center rounded-xl">
          <MilitaryTechOutlinedIcon className="!mt-4" />
          <div className="flex flex-col">
            <p>Total Rewards</p>
            <p>0</p>
          </div>
        </div>
      </div>

      <Divider className="!py-3" />
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: "background.paper",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Tabs
          className="!capitalize !px-7"
          orientation="horizontal"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{ borderRight: 1, borderColor: "divider" }}
        >
          <Tab
            className="!capitalize "
            label={<>Active challenge</>}
            {...a11yProps(0)}
          />
          <Tab
            className="!capitalize !px-5 "
            label={<>Past chalenge</>}
            {...a11yProps(1)}
          />
        </Tabs>
        <Divider />
        <div className="">
          <TabPanel value={value} index={0}>
            <img
              src={
                "	https://t4.ftcdn.net/jpg/02/95/58/83/360_F_295588366_okoiymNZE45lh3u7BEx8L9HiaIkwuWYZ.jpg"
              }
              alt=""
            />
            <p className="py-2 text-center font-bold text-xl mb-10">
              No Active challenge
            </p>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <img
              src={
                "	https://t4.ftcdn.net/jpg/02/95/58/83/360_F_295588366_okoiymNZE45lh3u7BEx8L9HiaIkwuWYZ.jpg"
              }
              alt=""
              className=""
            />
            <p className="py-4  text-xl text-center font-bold mb-10">
              No Past challenge
            </p>
          </TabPanel>
        </div>
      </Box>
    </>
  );
};
export default StoreRewards;
